var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hl-info",on:{"click":function($event){return _vm.detail('chemotherapy')}}},[_vm._v(" 化疗药物有效性及毒副作用 "),_c('i',{staticClass:"iconfont icon-right_medium"})])
}
var staticRenderFns = []

export { render, staticRenderFns }